import React from 'react'

export const ReservaEvento = () => {
  return (
    <div>ReservaEvento</div>
  )
}
